var map = {
	"./main/admin/admin.module.ngfactory": [
		"./src/app/main/admin/admin.module.ngfactory.js",
		"main-admin-admin-module-ngfactory"
	],
	"./main/hr/hr.module.ngfactory": [
		"./src/app/main/hr/hr.module.ngfactory.js",
		"main-hr-hr-module-ngfactory"
	],
	"./main/marketing/marketing.module.ngfactory": [
		"./src/app/main/marketing/marketing.module.ngfactory.js",
		"main-marketing-marketing-module-ngfactory"
	],
	"./main/pages/pages.module.ngfactory": [
		"./src/app/main/pages/pages.module.ngfactory.js",
		"main-pages-pages-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;